import React from "react";
import GenericCRUD from "@/components/common/GenericCRUD";

const config = {
  resource: "banners",
  singular: "banner",
  title: "Banners",
  subtitle: "Promotional banners across the website.",
  titleKey: "title",
  statusFilter: ["active", "draft"],
  columns: [
    {
      key: "title",
      label: "Title",
      render: (r) => (
        <div className="flex items-center gap-2">
          {r.image_desktop ? (
            <img src={r.image_desktop} alt="" className="w-12 h-8 rounded object-cover bg-white/10" />
          ) : null}
          <span className="text-white font-medium">{r.title}</span>
        </div>
      ),
    },
    { key: "location", label: "Location" },
    { key: "impressions", label: "Impressions" },
    { key: "clicks", label: "Clicks" },
    { key: "status", label: "Status", badge: true, className: "w-32" },
  ],
  fields: [
    { key: "title", label: "Title", type: "text" },
    { key: "location", label: "Location", type: "select", options: [
      { label: "Homepage Top", value: "homepage_top" },
      { label: "Homepage Middle", value: "homepage_middle" },
      { label: "Sidebar", value: "sidebar" },
      { label: "Footer", value: "footer" },
    ]},
    { key: "image_desktop", label: "Desktop Image", type: "image", folder: "banners" },
    { key: "image_tablet", label: "Tablet Image", type: "image", folder: "banners", hint: "Optional — falls back to desktop if empty" },
    { key: "image_mobile", label: "Mobile Image", type: "image", folder: "banners", hint: "Optional — falls back to desktop if empty" },
    { key: "link_url", label: "Link URL", type: "text" },
    { key: "start_at", label: "Start (ISO date)", type: "text" },
    { key: "end_at", label: "End (ISO date)", type: "text" },
    { key: "status", label: "Status", type: "select", options: [
      { label: "Active", value: "active" }, { label: "Draft", value: "draft" }
    ]},
  ],
  defaultValues: {
    status: "draft",
    impressions: 0,
    clicks: 0,
    image_desktop: "",
    image_tablet: "",
    image_mobile: "",
  },
};

export default function Banners() { return <GenericCRUD config={config} />; }
